import {Component, OnInit, OnDestroy, Input, OnChanges} from '@angular/core';

@Component({
  selector: "ModalBody",
  templateUrl: './modalbody.component.html',
  styleUrls: ['./modalbody.component.scss'],
})
export class ModalBody implements OnInit, OnDestroy, OnChanges  {

  @Input("type") type: string;
  @Input("text") text: string;
  @Input("link") link: string;
  public classes: any;

  constructor() {}

  ngOnInit(){
    this.classes = {
      info: this.type === 'info',
      error: this.type === 'error',
      pointer: this.link && this.link.length
    }
  }

  ngAfterViewInit(){
  }

  ngOnChanges(changes) {

  }

  ngOnDestroy(){
  }
}
